import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { EmissorContractStatus } from '../types/contractStatus';
import { useBenefitMigration } from './useBenefitMigration';
import { useContractStatusTracking } from './useContractStatusTracking';
export function useEmissorFlow() {
    const migration = useBenefitMigration();
    const migrated = migration.enabled && migration.state.kind === 'ready' && migration.read?.snapshot.phase === 'complete';
    const { isFeatureFlagWhiteListed } = useFeatureFlag(undefined, { isLoggedIn: true });
    const isEmissorEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_EMISSOR_ENABLED);
    const appDomain = useAppSelector(selectAppDomain);
    const { contract, status, isLoading } = useContractStatusTracking({
        appDomain,
        skip: !isEmissorEnabled || Boolean(migrated),
        redirectOnActive: false,
    });
    const isEmissorFlow = isEmissorEnabled && status === EmissorContractStatus.ACTIVATED;
    if (migrated && migration.read)
        return {
            isEmissorFlow: true,
            emissorContractId: migration.read.snapshot.emissorContractId,
            emissorContractLegalName: migration.read.emissorContractLegalName ?? null,
            isLoading: false,
        };
    return {
        isEmissorFlow,
        emissorContractId: isEmissorFlow ? (contract?.id ?? null) : null,
        emissorContractLegalName: isEmissorFlow ? (contract?.legalName ?? null) : null,
        isLoading,
    };
}
